module.exports = {
    BREADCRUMBS_V2_ID: 'breadcrumbsV2-app',
    DEFAULT_PLATFORM: 'desktop',
    MESSAGE_BUS_TOPICS: {
        NAVIGATION_PAGE_CHANGED: 'navigation.pageChanged',
        ANALYTIC_CHANGE_COMPONENT: 'event:change_component',
    },
};
